import styled from "@emotion/styled"
import AppBar from "@material-ui/core/AppBar"
import { docketTheme } from "theme"

export const StyledAppBar = styled(AppBar)`
  box-sizing: content-box;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 5.5rem;
  top: 7rem;
  background-color: ${docketTheme.colors.grey[95]};
`
